import { useQuery } from "@tanstack/react-query";
import api, { getStatus } from "@/lib/api";
import { PageHeader, Badge } from "@/components/Kit";
import { fmtDateTime } from "@/lib/date";
import { MessageCircle, Mail, Phone } from "lucide-react";

const ICON = { whatsapp: MessageCircle, email: Mail, sms: Phone };
const COLOR = { whatsapp: "#10B981", email: "#F59E0B", sms: "#06B6D4" };

export default function WhatsAppLog() {
  const { data: logs = [] } = useQuery({ queryKey: ["notifications"], queryFn: async () => (await api.get("/school/notifications")).data });
  const { data: status } = useQuery({ queryKey: ["status"], queryFn: getStatus, staleTime: 5 * 60_000 });
  const waLive = status?.whatsapp === "live";

  return (
    <div data-testid="whatsapp-page">
      <PageHeader title="Notifications & WhatsApp" subtitle="Every parent alert logged here" />

      {waLive ? (
        <div className="ep-card mb-4 border-emerald-500/40 bg-emerald-500/5 p-4">
          <p className="text-sm text-emerald-300">
            ✅ WhatsApp delivery is <b>live</b> via the Meta Cloud API. SMS and email are still logged only.
          </p>
        </div>
      ) : (
        <div className="ep-card mb-4 border-amber-500/40 bg-amber-500/5 p-4">
          <p className="text-sm text-amber-300">
            ⚠️ WhatsApp / SMS / Email delivery is currently <b>MOCKED</b>. Messages are generated and logged but not sent.
            Share your Meta Cloud API credentials to enable live delivery.
          </p>
        </div>
      )}

      <div className="space-y-2">
        {logs.map((n) => {
          const Icon = ICON[n.channel] || MessageCircle;
          return (
            <div key={n.id} className="ep-card flex items-start gap-3 p-4" data-testid={`notif-${n.id}`}>
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg" style={{ background: `${COLOR[n.channel]}22`, color: COLOR[n.channel] }}>
                <Icon size={17} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-sm font-medium text-white">To: {n.to}</span>
                  <Badge color={COLOR[n.channel]}>{n.channel}</Badge>
                </div>
                <p className="mt-1 whitespace-pre-line text-sm text-slate-400">{n.message}</p>
                <p className="mt-1 text-xs text-slate-600">{fmtDateTime(n.created_at)} · {n.status}</p>
              </div>
            </div>
          );
        })}
        {!logs.length && <p className="py-8 text-center text-slate-500">No notifications yet. Collect a fee or mark attendance to generate alerts.</p>}
      </div>
    </div>
  );
}
